<!-- Модальная оболочка быстрого создания транспорта. -->
<template>
  <BaseModal
    :visible="true"
    :title="modalTitle"
    size="xl"
    footer-align="start"
    elevated-footer
    @close="handleCancel"
  >
    <base-loader v-if="dataIsLoading" />

    <VehicleForm
      v-else
      ref="vehicleFormRef"
      :form-id="formId"
      :vehicle-id="vehicleId"
      :initial-data="formInitialData"
      :with-requisites="createMode"
      :success-message="successMessage"
      @saved="handleSaved"
      @submitting-change="isSubmitting = $event"
    />

    <template #footer>
      <base-primary-button
        class="form-btn"
        type="button"
        :form="formId"
        :disabled="isSubmitting || dataIsLoading"
        @click="submitForm"
      >
        <span v-if="isSubmitting">Сохранение...</span>
        <span v-else>Сохранить</span>
      </base-primary-button>

      <base-button
        class="form-btn"
        type="button"
        @click="handleCancel"
        :disabled="isSubmitting"
      >
        Отмена
      </base-button>
    </template>
  </BaseModal>
</template>

<script>
import { useVehicleStore } from "@/stores/vehicleStore";
import { getCompanyId } from "@/utils/userUtils";

import vehiclesApi from "@/services/api/vehiclesApi";
import VehicleForm from "@/components/Vehicle/Form.vue";

export default {
  name: "AddVehicleModal",

  components: {
    VehicleForm,
  },

  props: {
    vehicleId: {
      type: [String, Number],
      default: null,
    },
    initialData: {
      type: Object,
      default: () => ({}),
    },
  },

  emits: ["close", "vehicle-created", "vehicle-updated"],

  data() {
    return {
      formId: "vehicle-quick-create-form",
      isSubmitting: false,
      dataIsLoading: Boolean(this.vehicleId),
      companyId: getCompanyId(),
      formInitialData: { ...this.initialData },
    };
  },

  computed: {
    vehicleStore() {
      return useVehicleStore();
    },

    createMode() {
      return !this.vehicleId;
    },

    modalTitle() {
      return this.createMode
        ? "Создание нового транспорта"
        : "Редактирование транспорта";
    },

    successMessage() {
      return this.createMode
        ? "Новый транспорт успешно создан"
        : "Транспорт успешно обновлен";
    },
  },

  methods: {
    async submitForm() {
      await this.$refs.vehicleFormRef.submit();
    },

    async handleSaved(vehicle) {
      if (this.createMode && this.vehicleStore.fetchVehicles) {
        await this.vehicleStore.fetchVehicles();
      } else {
        this.vehicleStore.replaceVehicle(vehicle);
      }

      this.$emit(
        this.createMode ? "vehicle-created" : "vehicle-updated",
        vehicle
      );
      this.$emit("close");
    },

    async fetchVehicle() {
      if (this.createMode) return;

      this.dataIsLoading = true;

      try {
        const response = await vehiclesApi.show(
          this.companyId,
          this.vehicleId
        );

        this.formInitialData = response.data.result;
      } finally {
        this.dataIsLoading = false;
      }
    },

    handleCancel() {
      this.$emit("close");
    },
  },

  mounted() {
    this.fetchVehicle();
  },
};
</script>
